<div class="badge discount-badge"
     [class.discount-bg]="!discountTheme.color()"
     [style.backgroundColor]="discountTheme.color()">
  -{{ value }}%
</div>
